export default function useLayoutSlots() {
  const numbers = "0123456789";
  const upperCaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowerCaseLettters = "abcdefghijklmnopqrstuvwxyz";
  const specialCharacters = "!'^+%&/()=?_#${[]}|;:>÷`<.*-@";

  const generatePassword = (passwordLength = 8)  => {
    let password = [
      upperCaseLetters[Math.floor(Math.random() * upperCaseLetters.length)],
      lowerCaseLettters[Math.floor(Math.random() * lowerCaseLettters.length)],
      numbers[Math.floor(Math.random() * numbers.length)],
      specialCharacters[Math.floor(Math.random() * specialCharacters.length)]
  ];

    const all = upperCaseLetters + lowerCaseLettters + numbers + specialCharacters;
    for (let i = 4; i < passwordLength; i++) {
        password.push(all[Math.floor(Math.random() * all.length)]);
    }

    // Mezclamos los caracteres
    password = password.sort(() => Math.random() - 0.5);

    // Convertimos a string
    return password.join('');
  }

  return { generatePassword };

};
